// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_j7thA{position:-webkit-sticky;position:sticky;top:40px;margin-bottom:40px;z-index:1}.labels_p2Lg9{position:absolute;top:20px;left:0;z-index:2}.label_S38mY{margin:4px 0;padding:4px 15px;width:-webkit-max-content;width:-moz-max-content;width:max-content;color:#fff;background:#3600a6;font-weight:400;font-size:16px;line-height:22px;pointer-events:all}.label_S38mY.saleLabel_QsqjI{background:#272525}.image_ekJIF,.video_xtNVs{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.discontinued_b8Kkr{filter:brightness(70%)}.positionIndicator_OJhu4{margin-top:15px;color:#332f20;font-weight:300;font-size:14px;line-height:17px;text-align:center}.thumbnails_Yxotd{flex-wrap:wrap;margin:8px -8px;width:calc(100% + 16px)}.thumbnail_6KE-Z,.thumbnails_Yxotd{display:flex;justify-content:center}.thumbnail_6KE-Z{align-items:center;margin:8px;width:50px;height:50px;background:#fff;border:2px solid transparent;transition:border-color .125s ease-in-out;cursor:pointer}.thumbnail_6KE-Z.selected_MgEpV{border:2px solid #272525}.thumbnailImage_Zxxss{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
exports.locals = {
	"root": "root_j7thA",
	"labels": "labels_p2Lg9",
	"label": "label_S38mY",
	"saleLabel": "saleLabel_QsqjI",
	"image": "image_ekJIF",
	"video": "video_xtNVs",
	"discontinued": "discontinued_b8Kkr",
	"positionIndicator": "positionIndicator_OJhu4",
	"thumbnails": "thumbnails_Yxotd",
	"thumbnail": "thumbnail_6KE-Z",
	"selected": "selected_MgEpV",
	"thumbnailImage": "thumbnailImage_Zxxss"
};
module.exports = exports;
